import type { ComponentProps, FC } from 'react';
import { useController } from 'react-hook-form';

import { CheckboxRow } from 'components/CheckboxRow';

import { Container } from './styled';

import { ClearButton } from '../ClearButton';

interface ICheckboxOption {
    value: string | null;
    label: string;
}

type ICheckboxMenuProps = ComponentProps<typeof Container> & {
    inputName: string;
    options: ICheckboxOption[];
};

export const CheckboxMenu: FC<ICheckboxMenuProps> = ({
    inputName,
    options,
    ...props
}) => {
    const {
        field: { value: fieldValues, onChange },
    } = useController({ name: inputName });

    return (
        <Container {...props}>
            {options.map(({ value, label }) => (
                <CheckboxRow
                    key={value ?? 'null'}
                    value={value}
                    label={label}
                    inputName={inputName}
                />
            ))}
            <ClearButton
                disabled={!fieldValues?.length}
                onClick={() => onChange([])}
            >
                Clear
            </ClearButton>
        </Container>
    );
};

CheckboxMenu.defaultProps = {
    selected: [],
    onChange: () => {},
};
